document.addEventListener("DOMContentLoaded", function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      let cartCountElement = document.querySelector('.cart-count');
      if (cartCountElement) {
        cartCountElement.innerText = data.item_count;
      }
    });
});
